import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONFIG } from '../data/siteConfig';

const EFFECTIVE_DATE = '2026년 4월 23일';

export default function TermsPage() {
  return (
    <div>
      <title>이용약관 — KOA DETAILING</title>
      <meta name="description" content="KOA DETAILING(KOA) 이용약관 — 예약, 취소·환불, 책임 범위 등 서비스 이용 규정." />
      <meta name="robots" content="noindex" />
      <link rel="canonical" href="https://koa-asia.com/terms" />

      <div className="page-header">
        <div className="container">
          <span className="badge badge-primary" style={{ marginBottom: 16 }}>TERMS</span>
          <h1>이용약관</h1>
          <p>시행일: {EFFECTIVE_DATE}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container" style={{ maxWidth: 820 }}>
          <article style={{ lineHeight: 1.75, color: 'var(--text)' }}>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제1조 (목적)</h2>
              <p>본 약관은 {SITE_CONFIG.business.companyName}(이하 "회사")가 운영하는 KOA DETAILING 웹사이트(https://koa-asia.com, 이하 "사이트")에서 제공하는 세차 예약 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제2조 (정의)</h2>
              <ol style={listStyle}>
                <li>"서비스"란 회사가 운영하는 스팀 세차 예약 접수 및 관련 안내 서비스를 의미합니다.</li>
                <li>"이용자"란 사이트에 접속하여 서비스를 이용하는 모든 자를 의미합니다.</li>
                <li>"회원"이란 사이트에 개인정보를 제공하여 가입한 이용자로, 지속적으로 서비스를 제공받을 수 있는 자를 의미합니다.</li>
                <li>"비회원"이란 회원가입 없이 서비스를 이용하는 자를 의미합니다.</li>
                <li>"예약"이란 이용자가 지정한 일시에 세차 서비스를 받기 위해 사이트를 통해 제출한 신청을 의미합니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제3조 (약관의 게시와 개정)</h2>
              <ol style={listStyle}>
                <li>회사는 본 약관을 사이트 하단에 게시합니다.</li>
                <li>회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 시행일 7일 전 사이트에 공지합니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제4조 (회원가입)</h2>
              <ol style={listStyle}>
                <li>이용자는 이메일 또는 소셜 로그인(Google, Naver, Kakao)을 통해 회원가입할 수 있습니다.</li>
                <li>회원은 본 약관 및 개인정보처리방침에 동의하여야 가입이 완료됩니다.</li>
                <li>허위 정보 기재, 타인의 명의 도용 등의 경우 회사는 가입을 거부하거나 사후 회원 자격을 박탈할 수 있습니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제5조 (예약 서비스)</h2>
              <ol style={listStyle}>
                <li>이용자는 사이트를 통해 원하는 일시와 차종·서비스 조합으로 예약을 신청할 수 있습니다.</li>
                <li>예약은 회사가 "확정" 처리한 시점에 성립됩니다. 회사는 예약 접수 후 합리적 시간 내 확정 또는 거절 여부를 통보합니다.</li>
                <li>회사는 운영상 사유(기상 악화, 설비 점검 등)로 예약을 거절할 수 있으며, 이 경우 이용자에게 사유를 통지합니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제6조 (예약 취소 및 환불)</h2>
              <ol style={listStyle}>
                <li>
                  이용자는 다음 기준에 따라 예약을 취소할 수 있으며, 각 구간에 따른 환불·손해배상이 적용됩니다.
                  <ul style={{ ...listStyle, marginTop: 8 }}>
                    <li>이용일 10일 전까지 취소: 계약금 전액 환불</li>
                    <li>이용일 7일 전까지 취소: 계약금 환불 + 총 요금의 10% 배상</li>
                    <li>이용일 5일 전까지 취소: 계약금 환불 + 총 요금의 30% 배상</li>
                    <li>이용일 3일 전까지 취소: 계약금 환불 + 총 요금의 50% 배상</li>
                    <li>이용일 1일 전 및 당일 취소: 손해배상 책임 발생 (환불 불가)</li>
                  </ul>
                </li>
                <li>천재지변·질병 등 불가항력 사유는 제외되며, 증빙 제출 시 전액 환불됩니다.</li>
                <li>계약금 수취는 온라인 결제 시스템 도입 이후 적용됩니다. 본 조항 시행일 기준으로는 현장 결제만 운영되므로 실질적 계약금 개념이 적용되지 않을 수 있습니다.</li>
                <li>회사의 귀책사유로 서비스가 제공되지 않은 경우 전액 환불됩니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제7조 (서비스 이용 시 책임)</h2>
              <ol style={listStyle}>
                <li>회사는 세차 작업 중 작업자의 과실로 발생한 차량 손상에 대해 회사의 사업자 보험 범위 내에서 보상합니다.</li>
                <li>차량 내부의 귀중품(현금, 지갑, 스마트키, 시계, 전자기기 등)의 분실·손상은 회사가 책임지지 않으며, 이용자는 세차 전 귀중품을 직접 회수할 책임이 있습니다.</li>
                <li>차량에 이미 존재한 손상이나 노후로 인한 하자는 회사 책임에서 제외됩니다.</li>
                <li>서비스 이용 중 발생한 분쟁은 즉시 현장에서 확인하는 것을 원칙으로 합니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제8조 (이용자의 의무)</h2>
              <ol style={listStyle}>
                <li>이용자는 예약 시 정확한 정보를 제공해야 합니다.</li>
                <li>이용자는 허위 예약, 반복적 노쇼, 타인 명의 사용 등 서비스 운영을 저해하는 행위를 해서는 안 됩니다.</li>
                <li>이용자가 본 약관을 위반하는 경우 회사는 서비스 이용을 제한할 수 있습니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제9조 (회사의 의무)</h2>
              <ol style={listStyle}>
                <li>회사는 약속된 일시에 성실하게 서비스를 제공합니다.</li>
                <li>회사는 이용자의 개인정보를 개인정보처리방침에 따라 안전하게 보호합니다.</li>
                <li>회사는 관련 법령을 준수하며, 이용자의 정당한 민원에 신속히 대응합니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제10조 (개인정보 보호)</h2>
              <p>이용자의 개인정보 수집·이용·제공에 관한 사항은 별도의 <Link to="/privacy" style={{ color: 'var(--primary)' }}>개인정보처리방침</Link>에 따릅니다.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제11조 (면책 조항)</h2>
              <ol style={listStyle}>
                <li>회사는 천재지변, 전쟁, 정부의 조치 등 불가항력으로 인한 서비스 중단에 대해 책임을 지지 않습니다.</li>
                <li>이용자의 고의 또는 과실로 인한 손해에 대해 회사는 책임을 지지 않습니다.</li>
              </ol>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>제12조 (분쟁 해결 및 관할)</h2>
              <ol style={listStyle}>
                <li>서비스 이용과 관련하여 발생한 분쟁은 상호 협의하여 해결함을 원칙으로 합니다.</li>
                <li>협의가 이루어지지 않을 경우, 관련 법령 및 상관례에 따르며, 회사의 본점 소재지를 관할하는 법원을 전속 관할 법원으로 합니다.</li>
              </ol>
            </section>

            <p style={{ marginTop: 40, color: 'var(--text-dim)', fontSize: '0.9rem' }}>
              부칙: 본 약관은 {EFFECTIVE_DATE}부터 시행합니다.
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}

const sectionStyle = { marginBottom: 32 };
const h2Style = { fontSize: '1.15rem', marginBottom: 12, color: 'var(--primary)' };
const listStyle = { paddingLeft: 20, margin: 0 };
